const theme = {
  "primaryColors": [
    "#F1F7FE",
    "#E8F1FD",
    "#D1E3FA",
    "#A2C6F6",
    "#74AAF1",
    "#468EEC",
    "#1A73E8",
    "#135BB9",
    "#0E448B",
    "#092D5D",
    "#05172E",
    "#020B17"
  ]
};

export default theme;